// Promoted into the design system as DSSheet. Kept as a re-export so existing
// imports keep working; new code should import DSSheet from the design system.
import { DSSheet } from '../design-system/primitives';

export default DSSheet;
